export default __webpack_public_path__ + "static/media/daima.30793801.jpg";